import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_HUBSPOT_TICKET,
  DELETE_HUBSPOT_TICKET,
  GET_HUBSPOT_TICKET,
  GET_HUBSPOT_TICKETS,
  NATIVE_SUPPORT_TICKETS_LIST_GET,
  NATIVE_SUPPORT_TICKET_CONFIG_GET,
  NATIVE_SUPPORT_TICKET_CREATE,
  NATIVE_SUPPORT_TICKET_DETAIL_GET,
  NATIVE_SUPPORT_TICKET_REPLY_CREATE,
  REPLY_HUBSPOT_TICKET,
  UPDATE_HUBSPOT_TICKET,
} from 'setup/redux/Actions/TicktingFunctonality/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_HUBSPOT_TICKETS, fetchData)
  yield takeEvery(GET_HUBSPOT_TICKET, fetchData)
  yield takeEvery(CREATE_HUBSPOT_TICKET, fetchData)
  yield takeEvery(UPDATE_HUBSPOT_TICKET, fetchData)
  yield takeEvery(DELETE_HUBSPOT_TICKET, fetchData)
  yield takeEvery(REPLY_HUBSPOT_TICKET, fetchData)
  yield takeEvery(NATIVE_SUPPORT_TICKET_CONFIG_GET, fetchData)
  yield takeEvery(NATIVE_SUPPORT_TICKETS_LIST_GET, fetchData)
  yield takeEvery(NATIVE_SUPPORT_TICKET_DETAIL_GET, fetchData)
  yield takeEvery(NATIVE_SUPPORT_TICKET_CREATE, fetchData)
  yield takeEvery(NATIVE_SUPPORT_TICKET_REPLY_CREATE, fetchData)
}

export default dataSaga
